var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-table-2-layout",
      attrs: { "data-test": "work-style-area" },
    },
    [
      _c(
        "scout-form",
        { attrs: { label: "志向の指定", "has-child": "" } },
        [
          _c(
            "div",
            {
              staticClass: "boss-table-2-item boss-table-2-item-body",
              class: [{ "is-modified": _vm.isModified }],
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "boss-layout boss-layout-start boss-layout-gap-large",
                },
                [
                  _vm._l(_vm.options, function (option, i) {
                    return _c(
                      "label",
                      {
                        key: i,
                        staticClass: "pega-input",
                        attrs: { "data-test": "label-" + i },
                      },
                      [
                        _c("input", {
                          staticClass: "boss-input-checkbox",
                          attrs: { "data-test": "radio-" + i, type: "radio" },
                          domProps: {
                            checked: _vm.selectedOption === option.key,
                            value: option.key,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit(
                                "update:selectedOption",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(_vm._s(option.label) + "\n        "),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "boss-annotation-text" }, [
                    _vm._v(
                      "\n          ※スライドバーを動かしてご利用ください\n        "
                    ),
                  ]),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.workStylesData, function (workStyle, i) {
            return _c("scout-form-work-style-item", {
              key: i,
              attrs: {
                volition: workStyle.volition,
                name: workStyle.name,
                "left-label": workStyle.firstLabel,
                "right-label": workStyle.lastLabel,
                "data-test": "item-" + workStyle.id,
              },
              on: {
                "update:volition": function ($event) {
                  return _vm.update($event, workStyle.id)
                },
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }